import { Link } from "react-router-dom";

export const YumyButton = ({ children, onClick, ...props }) => {
  return (
    <button
      onClick={onClick}
      className="
        relative rounded-full px-4 py-4 text-base text-white-100
        text-center
        bg-yumyGreen hover:bg-yumyGreenHover
        transition-all duration-300
        active:scale-95

        after:content-['']
        after:absolute after:inset-0 after:rounded-full after:pointer-events-none
        
        after:ring-4 after:ring-yumyGreen400/40
        after:blur-[1px]

        after:opacity-0 after:scale-100
        
        after:transition-all after:duration-300 after:ease-out
        
        active:after:opacity-100
        active:after:scale-x-105
        active:after:scale-y-125
      "
      {...props}
    >
      {children}
    </button>
  );
};

export const YumyButtonLinkGrey = ({ children, href, ...props }) => {
  return (
    <Link
      to={href}
      className="
        relative rounded-full px-4 py-4 text-base 
        text-yumyGreen hover:text-yumyGreen
        text-center
        bg-grayScale900-4 hover:bg-grayScale900-8
        transition-all duration-300
        active:scale-95

        after:content-['']
        after:absolute after:inset-0 after:rounded-full after:pointer-events-none
        
        after:ring-4 after:ring-yumyGreen400/40
        after:blur-[1px]

        after:opacity-0 after:scale-100
        
        after:transition-all after:duration-300 after:ease-out
        
        active:after:opacity-100
        active:after:scale-x-105
        active:after:scale-y-125
      "
      {...props}
    >
      {children}
    </Link>
  );
};
